const tabsComponent = props => (
  <div className="real-estate-tabs">
    <div className="tabs-container__img investment__img">
      <img src={props.img} alt={props.label} />
    </div>
    <div className="tabs-container__content investment__content">
      <h3 className="tabs-container__tab-heading investment__tab-heading">{props.label}</h3>
      <ul className="tabs-container__description investment__description" dangerouslySetInnerHTML={{ __html: props.description }}></ul>
    </div>
  </div>
);

export default tabsComponent;